export default __webpack_public_path__ + "static/media/profile4.d8164059.svg";